/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    header: "header",
    month: "month",
    chevron: "chevron",
    suffix: "suffix",
    yearSuffix: "year--suffix",
    yearWrap: "year-wrap",
    textReverse: "text--reverse",
};
export const ICON = {
    chevronLeft: "chevron-left",
    chevronRight: "chevron-right",
};
//# sourceMappingURL=resources.js.map
